import React, { useState, useEffect } from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { SiteScanApply } from '../SiteScanApply';
import CreateTenableApply from './CreateTenableApply';
import { SiteTitle } from '../SiteTitle';

function TenableBackground() {
    const [value, setValue] = useState('1');
    const [tenablePage, setTenablePage] = useState(localStorage.getItem('tenable_page') === 'true');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        const handleTenablePageChanged = () => {
            const tenablePageValue = localStorage.getItem('tenable_page') === 'true';
            setTenablePage(tenablePageValue);
        };


        window.addEventListener('tenablePageChanged', handleTenablePageChanged);
        return () => {
            window.removeEventListener('tenablePageChanged', handleTenablePageChanged);
        };
    }, []);

    return (
        <div>
            <SiteTitle />

            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="tracking tabs"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "blue",
                            }
                        }}
                    >
                        <Tab label="檢測網頁申請" value="1" />
                        {tenablePage && <Tab label="檢測主機申請" value="2" />}
                    </Tabs>
                </Box>
                <TabPanel value="1">
                    <SiteScanApply />
                </TabPanel>
                {tenablePage && (
                    <TabPanel value="2">
                        <CreateTenableApply />
                    </TabPanel>
                )}
            </TabContext>
        </div>
    );
}

export default TenableBackground;
